import React, { useEffect } from 'react';

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;
    
    // Возвращаем исходный заголовок при размонтировании
    return () => {
      document.title = originalTitle;
    };
  }, [title]);

  return null; // Компонент не рендерит ничего
};

export default PageTitle;

